import { render, staticRenderFns } from "./twoPage.vue?vue&type=template&id=b9fbebf2&"
import script from "./twoPage.vue?vue&type=script&lang=js&"
export * from "./twoPage.vue?vue&type=script&lang=js&"
import style0 from "./twoPage.vue?vue&type=style&index=0&id=b9fbebf2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports